import { TransactionType } from 'graphql'
import { isToStore, isToLoss, isToObsolete } from 'graphql/utils/transaction-types'
import { EuiFormRowProps } from '@equipmentshare/ds2'
import { InventoryLocation } from 'inventory-web'
import InventoryLocationPicker from 'components/InventoryLocationPicker'

export type ToEntityType = InventoryLocation | null

export type ToEntityProps = {
	type: TransactionType,
	selectedItem?: ToEntityType,
	selectedItemId?: number,
	onChange: ( id: number, item?: ToEntityType ) => void,
	formRowProps?: Partial<EuiFormRowProps>,
}

export default function ToEntity( { type, onChange, selectedItem, selectedItemId, formRowProps }: ToEntityProps ) {
	if ( isToStore( type ) ) {
		return (
			<InventoryLocationPicker
				label="To Store"
				onChange={onChange}
				selectedInventoryLocation={selectedItem as InventoryLocation}
				selectedInventoryLocationId={selectedItemId}
				formRowProps={formRowProps}
				isInvalid={formRowProps?.isInvalid}
			/>
		)
	}

	if ( isToLoss( type ) ) {
		return <h3>To Loss</h3>
	}

	if ( isToObsolete( type ) ) {
		return <h3>To Obsolete</h3>
	}

	return null
}
